(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWchameleon_atlas_", frames: [[119,796,142,38],[480,44,21,21],[279,756,92,80],[420,406,92,80],[112,836,60,40],[174,836,60,40],[0,872,54,36],[448,862,54,36],[306,864,68,34],[236,838,68,34],[376,864,70,28],[279,722,70,28],[372,510,105,96],[480,20,26,22],[426,320,58,70],[56,808,54,62],[426,248,58,70],[373,806,68,56],[424,128,78,60],[443,806,66,54],[424,190,74,56],[373,756,90,48],[0,808,54,62],[480,67,22,20],[210,178,212,112],[0,292,212,112],[214,292,210,112],[208,510,162,116],[388,0,90,126],[0,614,158,118],[480,0,32,18],[0,406,208,102],[210,406,208,102],[0,510,206,102],[160,628,198,92],[0,210,170,64],[372,608,117,72],[160,722,117,72],[360,682,117,72],[0,734,117,72],[0,0,208,208],[210,0,176,176]]}
];


// symbols:



(lib.ChameleonBackRidge = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonEye = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonFace_0010001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonFace_0010002 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonFootALG_0010001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonFootALG_0010002 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonFootBLG_0010001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonFootBLG_0010002 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonFootCLG_0010001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonFootCLG_0010002 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonFootDLG_0010001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonFootDLG_0010002 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.chameleonhead_excited_001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.chameleonhead_excited_001_overlay = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonLegAUpperLG_001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonLegBLowerLG_001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonLegBUpperLG_ = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonLegCLowerLG_001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonLegCUpperLG_001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonLegDLowerLG_001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonLegDUpperLG_001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonLowerJaw_001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonLowerLegALG_001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonNose = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonTailNew0001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonTailNew0002 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonTail_excited_001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonTail_excited_002 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonTail_excited_003 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonTail_excited_004 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonTongue = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonTorsoNew0001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonTorsoNew0002 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonTorso_Excited_001 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonTorso_Excited_003 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.ChameleonTorso_Excited_003_overlay = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.green_chameleon2 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib.green_chameleon3 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();



(lib.green_chameleon4 = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(38);
}).prototype = p = new cjs.Sprite();



(lib.green_chameleon = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(39);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(40);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWchameleon_atlas_"];
	this.gotoAndStop(41);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.green_chameleon4_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.green_chameleon4();
	this.instance.parent = this;
	this.instance.setTransform(-21,-12.5,0.321,0.321);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.green_chameleon4_1, new cjs.Rectangle(-21.1,-12.6,37.8,23.3), null);


(lib.green_chameleon3_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.green_chameleon3();
	this.instance.parent = this;
	this.instance.setTransform(-21,-12.5,0.321,0.321);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.green_chameleon3_1, new cjs.Rectangle(-21.1,-12.6,37.8,23.3), null);


(lib.green_chameleon2_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.green_chameleon2();
	this.instance.parent = this;
	this.instance.setTransform(-21,-12.5,0.321,0.321);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.green_chameleon2_1, new cjs.Rectangle(-21.1,-12.6,37.8,23.3), null);


(lib.green_chameleon_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.green_chameleon();
	this.instance.parent = this;
	this.instance.setTransform(-21,-12.5,0.321,0.321);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.green_chameleon_1, new cjs.Rectangle(-21.1,-12.6,37.8,23.3), null);


(lib.ChameleonTongue_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ChameleonTongue();
	this.instance.parent = this;
	this.instance.setTransform(0.3,-0.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonTongue_1, new cjs.Rectangle(0,-0.2,16.3,9.1), null);


(lib.ChameleonLowerLegALG_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ChameleonLowerLegALG_001();
	this.instance.parent = this;
	this.instance.setTransform(-9.1,-10.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonLowerLegALG_001_1, new cjs.Rectangle(-9.1,-10.7,27,31), null);


(lib.ChameleonLowerJaw_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ChameleonLowerJaw_001();
	this.instance.parent = this;
	this.instance.setTransform(-2,-3.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonLowerJaw_001_1, new cjs.Rectangle(-2.1,-3.4,45.2,24), null);


(lib.ChameleonLegDUpperLG_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ChameleonLegDUpperLG_001();
	this.instance.parent = this;
	this.instance.setTransform(-12.9,-9.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonLegDUpperLG_001_1, new cjs.Rectangle(-12.9,-9.4,37,28), null);


(lib.ChameleonLegDLowerLG_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ChameleonLegDLowerLG_001();
	this.instance.parent = this;
	this.instance.setTransform(-11.1,-9.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonLegDLowerLG_001_1, new cjs.Rectangle(-11.1,-9.1,33,27), null);


(lib.ChameleonLegCUpperLG_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ChameleonLegCUpperLG_001();
	this.instance.parent = this;
	this.instance.setTransform(-15.1,-10.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonLegCUpperLG_001_1, new cjs.Rectangle(-15.1,-10.4,39,30), null);


(lib.ChameleonLegCLowerLG_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ChameleonLegCLowerLG_001();
	this.instance.parent = this;
	this.instance.setTransform(-11.8,-10,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonLegCLowerLG_001_1, new cjs.Rectangle(-11.8,-10,34,28), null);


(lib.ChameleonLegBUpperLG__1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ChameleonLegBUpperLG_();
	this.instance.parent = this;
	this.instance.setTransform(-9.7,-11.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonLegBUpperLG__1, new cjs.Rectangle(-9.7,-11.7,29,35), null);


(lib.ChameleonLegBLowerLG_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ChameleonLegBLowerLG_001();
	this.instance.parent = this;
	this.instance.setTransform(-9.1,-10.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonLegBLowerLG_001_1, new cjs.Rectangle(-9.1,-10.7,27,31), null);


(lib.ChameleonLegAUpperLG_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ChameleonLegAUpperLG_001();
	this.instance.parent = this;
	this.instance.setTransform(-10.1,-11.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonLegAUpperLG_001_1, new cjs.Rectangle(-10.1,-11.7,29,35), null);


(lib.chameleonhead_excited_001_overlay_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.chameleonhead_excited_001_overlay();
	this.instance.parent = this;
	this.instance.setTransform(0.2,3.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.chameleonhead_excited_001_overlay_1, new cjs.Rectangle(-2,0.8,18.2,16), null);


(lib.chameleonhead_excited_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.chameleonhead_excited_001();
	this.instance.parent = this;
	this.instance.setTransform(-2.7,2.4,0.172,0.172);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.chameleonhead_excited_001_1, new cjs.Rectangle(-20.4,-19.7,57.8,59.5), null);


(lib.ChameleonFootDLG_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,clean:2,clean_loop:3,glow:4,glow_loop:5,wash:6,wash_stop:209,"final":210,final_loop:211});

	// Layer 3
	this.instance = new lib.ChameleonFootDLG_0010001();
	this.instance.parent = this;
	this.instance.setTransform(-11.9,-4,0.5,0.5);

	this.instance_1 = new lib.ChameleonFootDLG_0010002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-11.9,-4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},206).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.9,-4,35,14);


(lib.ChameleonFootBLG_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"final":210,"final_loop":211});

	// Layer 4
	this.instance = new lib.ChameleonFootBLG_0010001();
	this.instance.parent = this;
	this.instance.setTransform(-10.9,-4.2,0.5,0.5);

	this.instance_1 = new lib.ChameleonFootBLG_0010002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-10.9,-4.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},206).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10.9,-6.7,27,20.6);


(lib.ChameleonFootALG_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"final":210,"final_loop":211});

	// Layer 5
	this.instance = new lib.ChameleonFootALG_0010001();
	this.instance.parent = this;
	this.instance.setTransform(-12,-5,0.5,0.5);

	this.instance_1 = new lib.ChameleonFootALG_0010002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-12,-5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},53).to({state:[]},153).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-12,-7.9,30,23);


(lib.chameleon_mouthGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(1.5,1,1).p("AAOAqIABADIAAAAQABAAACAAQABAEAAABQABABABAAQAAgBACABIAAAAQAAACACABQABACAEAAQAAAAABABQACACADAAQAEACAFgCQAKgFAFgPQAGgRgKgDIAAABQgZgLgYgdQgZgigHgCIAAgBQgHgCgIAAQgIAAgDACQgBAAAAAAQgIAGgBAGQgBAGAHAGQACACAEABQAAAAABAAQABAEABADIAAABQgBACABABQAAABALAMQgBACAAABQABAAADgBAAJAnQgDgCgCABQgCgCABgBQAAgBABAAQgBgBgDAAQgCgBAAAAQgBgBAAgBQAAgBAAAAQgBAAgCAAQgDABgBgBQgBgCACgEIgBAAQgBAAgBAAQgCABgBgBQAAgCAAgBIAAgBIAAgBIAAAAQgDAAgBACIgCgCQAAgCABgCQAAgBAAAAQAAAAgBAAQAAABgCAAIAAgBQgBgBABgDQAAAAAAgBIgBgBIAAABQgDACgCgCQAAgBAAgBQABgCACgCAggADIACgF");
	this.shape.setTransform(6.6,7.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.chameleon_mouthGlow, new cjs.Rectangle(-0.6,0.6,14.5,14), null);


(lib.chameleon_legGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(1.5,1,1).p("ACbhVQgSgIgbAAQgcAAgJAmQgJAmAmgBQAlgBgIgWQgIgWgSAMQgFAGgCADQAAAFAEADQADACAEgBQADgCAEgEQAEgFgFgDQgEgEgDADQgDADABACQAAABgBAAQgBgDACgCQACgDADgBQAIABABAFQAAADgBACQgBABgBACQgCADgDABQgIAEgDgCQgEgDgCgDQgCgDAFgKQAOgVAUASQAUATgUASQgVARgdgPQgdgRAPggQAOghAVgCQATgFAOACQAOACAbAMQAaAMgJAsQgJApgiAXQgjAWgwAOQg9AXg2AGQg1AHgzgEQgLgBgJgBQgMgBgIAAQAMgfgRgXQASADAHABQB3AUBfgTQBngVAVgiQAVgkgIgRQgHgRgSgJg");
	this.shape.setTransform(21.7,11.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.chameleon_legGlow, new cjs.Rectangle(1,0,41.3,22.5), null);


(lib.chameleon_footGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(1.5,1,1).p("AiygYIAAACQABAAABABQgFgBgGABQgJABgEAHQgFAHAHAGQAIAEAIABQgCACABADIABAEQAAABABAAQABABAAABQAOAJAOgFQAEgCAEgCQACACACAAQAOAFAQgCQAagFgPgRQgDgDgKgBQACgFgHgIQgEgEgOgBQgNgCgBgBQAAgBgBAAQgBgCgEgFQgEgEgEAAQgHgEgGAEQgCADAAACQgBADABAFgAA7AcQABAFANgBQAEgBAEAAQAAACACADQACADAMgBQAQgCANADQAHABAPAAQAbAAATgFQAKgDgBgIQgCgIgKgEQgIgDgJAAQgDgCgEgCQgZgHgqAOIAAAAQgpgKgBAKQgEAKAFAGg");
	this.shape.setTransform(-7.9,-0.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.chameleon_footGlow, new cjs.Rectangle(-29.1,-5.8,42.6,10), null);


(lib.chameleon_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#F4F400").ss(2,1,1).p("AgEASQgJgJAHgOQAHgPAJAD");
	this.shape.setTransform(1.1,2.9);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#F9F900").ss(2,1,1).p("AiPhOQAJAEAHACQAHADAKAHQAKAHAOAGQAAAAA5ATQA8AUAXAFQACAAAZAEQARACAWAHQAXAHAQAHQgdATgWAJQgrATgYAEQglAHgRgBQgPgBgWgHQgkgOgRgbQgQgZgVgZQgRgVgBgB");
	this.shape_1.setTransform(16.5,9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.chameleon_backGlow, new cjs.Rectangle(-0.9,0.1,34.3,17.8), null);


(lib.blueglowtail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(1.5,1,1).p("ACbhVQgSgIgbAAQgcAAgJAmQgJAmAmgBQAlgBgIgWQgIgWgSAMQgFAGgCADQAAAFAEADQADACAEgBQADgCAEgEQAEgFgFgDQgEgEgDADQgDADABACQAAABgBAAQgBgDACgCQACgDADgBQAIABABAFQAAADgBACQgBABgBACQgCADgDABQgIAEgDgCQgEgDgCgDQgCgDAFgKQAOgVAUASQAUATgUASQgVARgdgPQgdgRAPggQAOghAVgCQATgFAOACQAOACAbAMQAaAMgJAsQgJApgiAXQgjAWgwAOQg9AXg2AGQg1AHgzgEQgLgBgJgBQgMgBgIAAQAMgfgRgXQASADAHABQB3AUBfgTQBngVAVgiQAVgkgIgRQgHgRgSgJg");
	this.shape.setTransform(21.7,11.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowtail, new cjs.Rectangle(1,0,41.3,22.5), null);


(lib.blueglowmouth = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(1.5,1,1).p("AAOAqIABADIAAAAQABAAACAAQABAEAAABQABABABAAQAAgBACABIAAAAQAAACACABQABACAEAAQAAAAABABQACACADAAQAEACAFgCQAKgFAFgPQAGgRgKgDIAAABQgZgLgYgdQgZgigHgCIAAgBQgHgCgIAAQgIAAgDACQgBAAAAAAQgIAGgBAGQgBAGAHAGQACACAEABQAAAAABAAQABAEABADIAAABQgBACABABQAAABALAMQgBACAAABQABAAADgBAAJAnQgDgCgCABQgCgCABgBQAAgBABAAQgBgBgDAAQgCgBAAAAQgBgBAAgBQAAgBAAAAQgBAAgCAAQgDABgBgBQgBgCACgEIgBAAQgBAAgBAAQgCABgBgBQAAgCAAgBIAAgBIAAgBIAAAAQgDAAgBACIgCgCQAAgCABgCQAAgBAAAAQAAAAgBAAQAAABgCAAIAAgBQgBgBABgDQAAAAAAgBIgBgBIAAABQgDACgCgCQAAgBAAgBQABgCACgC");
	this.shape.setTransform(6.6,7.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#FFFF00").ss(1.5,1,1).p("AAAADIABgF");
	this.shape_1.setTransform(3.4,7.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowmouth, new cjs.Rectangle(-0.6,0.6,14.5,14), null);


(lib.blueglowfeet = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(1.5,1,1).p("AiygYIAAACQABAAABABQgFgBgGABQgJABgEAHQgFAHAHAGQAIAEAIABQgCACABADIABAEQAAABABAAQABABAAABQAOAJAOgFQAEgCAEgCQACACACAAQAOAFAQgCQAagFgPgRQgDgDgKgBQACgFgHgIQgEgEgOgBQgNgCgBgBQAAgBgBAAQgBgCgEgFQgEgEgEAAQgHgEgGAEQgCADAAACQgBADABAFgAA7AcQABAFANgBQAEgBAEAAQAAACACADQACADAMgBQAQgCANADQAHABAPAAQAbAAATgFQAKgDgBgIQgCgIgKgEQgIgDgJAAQgDgCgEgCQgZgHgqAOIAAAAQgpgKgBAKQgEAKAFAGg");
	this.shape.setTransform(-7.9,-0.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowfeet, new cjs.Rectangle(-29.1,-5.8,42.6,10), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(2,1,1).p("AiMhOQAJAEAHADQAGACAKAIQAKAHAOAFQABAAA4ATQA8AVAXAEQADABAZAEQARABAWAHQAXAHAPAIQgcASgWAKQgsATgYAEQgkAGgRgBQgPAAgWgIQgkgOgSgbQgQgZgUgYQgRgWgBgBQgKgJAIgPQAHgPAKADg");
	this.shape.setTransform(16.2,9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(-0.9,0.1,34.3,17.8), null);


(lib.ChameleonTorso_Excited_003_overlay_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.ChameleonTorso_Excited_003_overlay();
	this.instance.parent = this;
	this.instance.setTransform(-38.7,-16,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonTorso_Excited_003_overlay_1, new cjs.Rectangle(-40.1,-22.3,86.4,40), null);


(lib.ChameleonTorso_Excited_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ChameleonTorso_Excited_003();
	this.instance.parent = this;
	this.instance.setTransform(-49.7,-18,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonTorso_Excited_003_1, new cjs.Rectangle(-49.7,-22.3,99,50.4), null);


(lib.ChameleonTorso_Excited_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ChameleonTorso_Excited_001();
	this.instance.parent = this;
	this.instance.setTransform(-49.7,-23.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonTorso_Excited_001_1, new cjs.Rectangle(-49.7,-23.9,103,51.4), null);


(lib.ChameleonTail_excited_004_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ChameleonTail_excited_004();
	this.instance.parent = this;
	this.instance.setTransform(-60,-32.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonTail_excited_004_1, new cjs.Rectangle(-60,-32.2,79,59), null);


(lib.ChameleonTail_excited_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ChameleonTail_excited_003();
	this.instance.parent = this;
	this.instance.setTransform(-49.2,-39.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonTail_excited_003_1, new cjs.Rectangle(-49.2,-39.2,50.7,63), null);


(lib.ChameleonTail_excited_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ChameleonTail_excited_002();
	this.instance.parent = this;
	this.instance.setTransform(-60,-31.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonTail_excited_002_1, new cjs.Rectangle(-60,-31.2,81,58), null);


(lib.ChameleonTail_excited_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.ChameleonTail_excited_001();
	this.instance.parent = this;
	this.instance.setTransform(-50,-26,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonTail_excited_001_1, new cjs.Rectangle(-50,-26,105,56), null);


(lib.ChameleonNose_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.ChameleonNose();
	this.instance.parent = this;
	this.instance.setTransform(-3.5,-3.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.ChameleonNose_1, new cjs.Rectangle(-3.5,-3.4,11,10), null);


(lib.ChameleonEye_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":60,"final":61,"final_loop":62});

	// Layer 4
	this.instance = new lib.ChameleonEye();
	this.instance.parent = this;
	this.instance.setTransform(-3.7,4.4,0.386,0.381,0,180,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(60).to({_off:true},6).wait(145));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.8,-3.7,8.3,8.2);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_few = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(42.3,6.2,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.3,4.3,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.9,6.5,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54,11,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_few, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(45.6,4.1,0.326,0.326,-155.4,0,0,11.3,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_2, new cjs.Rectangle(27.1,-14.9,46.8,40.7), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.ChameleonFootCLG_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":79,glowclean:80,glowclean_loop:81,"final":82,"final_loop":83});

	// Layer 4
	this.instance = new lib.ChameleonFootCLG_0010001();
	this.instance.parent = this;
	this.instance.setTransform(-10.2,-5.9,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(8.5,1,0.5,0.5,0,0,0,47.7,10.1);

	this.instance_2 = new lib.ChameleonFootCLG_0010002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-10.2,-5.9,0.5,0.5);

	this.instance_3 = new lib.chameleon_footGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-24.8,-3.9,2.246,2.149,0,0,0,-7.7,-0.8);

	this.glow = new lib.blueglowfeet();
	this.glow.parent = this;
	this.glow.setTransform(-24.8,-3.9,2.246,2.149,0,0,0,-7.7,-0.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},8).to({state:[{t:this.instance_2},{t:this.instance_1}]},65).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_2}]},2).to({state:[]},2).wait(131));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10.2,-5.9,34,17);


(lib.ChameleonFace_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"glowclean":210,"glowclean_loop":211,"final":212,"final_loop":213});

	// Layer 4
	this.instance = new lib.ChameleonFace_0010001();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2.2,0.5,0.5);

	this.instance_1 = new lib.ChameleonFace_0010002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-2,-2.2,0.5,0.5);

	this.instance_2 = new lib.chameleon_mouthGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(17.8,27.6,2.107,2.107,-48.7,0,0,6.7,7.5);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(17.8,27.6,2.107,2.107,-48.7,0,0,6.7,7.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1},{t:this.glow}]},204).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2,-2.2,46,40);


(lib.chameleon_footMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{mud:0,soap:27,"clean":50});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_27 = function() {
		/* stop();*/
	}
	this.frame_50 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(27).call(this.frame_27).wait(23).call(this.frame_50).wait(11));

	// Layer 6
	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(2.5,1.6,0.069,0.069,0,0,0,47.6,9.4);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(3.8,1,0.104,0.104,-28.5,0,0,48.3,5.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},27).to({state:[]},23).wait(11));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.902)").s().p("AgNAKIgCgBQgCACgEAAQgIAAAAgJQAAgCACgBQADgDADAAIAEABIACAAIAFgBIAEABIAFgBIABgBIAIAAQAAgBAAAAQAAgBABAAQAAgBABAAQAAAAABAAIADgBIAAAAQAAgBABAAQAAAAABAAQAAAAABAAQABAAABAAQAEAAACAEQAFACAAAEQAAACgCADQgDADgFgCQAAABAAAAQgBABAAAAQgBAAAAAAQgBAAgBAAQgHAAgCgCIgEADIgEAAIgBgBQgEADgDAAIgEgBg");
	this.shape.setTransform(3,1.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},21).wait(40));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,6.1,2.3);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.ChameleonTorsoNew_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":90});

	// Layer 3
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(2.9,-0.9,0.577,0.579,0,-153.6,-153.8,35.4,10.8);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-19.7,-4.3,0.577,0.579,0,32.7,32.5,35.5,10.7);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(29.2,-0.7,0.577,0.579,0,-164.4,-164.7,35.9,10.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},89).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ChameleonTorsoNew = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":60,"glowclean":61,"glowclean_loop":62,"final":63,"final_loop":64});

	// Layer 4
	this.instance = new lib.ChameleonTorsoNew0001();
	this.instance.parent = this;
	this.instance.setTransform(-49.7,-23.7,0.5,0.5);

	this.instance_1 = new lib.ChameleonTorsoNew0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-49.7,-23.7,0.5,0.5);
	this.instance_1._off = true;

	this.instance_2 = new lib.chameleon_backGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(4.9,-3.7,2.158,2.158,-8,0,0,16.2,8.8);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(4.9,-3.7,2.158,2.158,-8,0,0,16.2,8.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},8).to({state:[{t:this.instance_1}]},46).to({state:[{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(150));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(2).to({_off:false},0).to({_off:true},2).wait(2).to({_off:false},0).wait(57).to({_off:true},2).wait(150));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-49.7,-23.9,104,51.2);


(lib.ChameleonTailNew_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":90});

	// Layer 3
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-7,9.9,0.407,0.408,0,164.7,164.5,35.6,10.6);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(7.6,9,0.407,0.408,0,164.7,164.5,36,10.7);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-21.6,13.1,0.407,0.408,0,32.7,32.5,35.6,10.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},89).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ChameleonTailNew = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":60,"glowclean":61,"glowclean_loop":62,"final":63,"final_loop":64});

	// Layer 4
	this.instance = new lib.ChameleonTailNew0001();
	this.instance.parent = this;
	this.instance.setTransform(-50,-25.7,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(3.3,14.7,0.25,0.25,0,0,0,47.6,10.2);

	this.instance_2 = new lib.left_over_bubbles_few();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-7.3,16.6,0.5,0.5,0,0,0,47.8,9.3);

	this.instance_3 = new lib.left_over_bubbles_2();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-20.3,14.6,0.75,0.75,0,0,0,48.8,4.8);

	this.instance_4 = new lib.ChameleonTailNew0002();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-50,-25.7,0.5,0.5);

	this.instance_5 = new lib.chameleon_legGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(1.3,-1.2,2.417,2.322,0,0,0,21.4,11.1);

	this.glow = new lib.blueglowtail();
	this.glow.parent = this;
	this.glow.setTransform(1.3,-1.2,2.417,2.322,0,0,0,21.4,11.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},6).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},48).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_4}]},2).to({state:[]},2).to({state:[]},156).wait(23));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-50,-25.7,106,56);


(lib.ChameleonBackRidge_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":60,"glowclean":61,"glowclean_loop":62,"final":63,"final_loop":64});

	// Layer 2
	this.instance = new lib.ChameleonBackRidge();
	this.instance.parent = this;
	this.instance.setTransform(-37.5,-4.2,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-6,7.6,0.5,0.5,0,180,0,50.4,5.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance},{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance},{t:this.instance_1}]},8).to({state:[{t:this.instance},{t:this.instance_1}]},49).to({state:[{t:this.instance}]},2).to({state:[]},2).to({state:[]},1).wait(146));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-37.5,-4.2,71,19);


(lib.water_drops_009 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// WET DROPS
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(171.9,1.4,0.486,0.486,0,0,0,4.8,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(159,15.9,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(130.1,22,0.486,0.486);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,17,18,23);


(lib.ChameleonFootC_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.chameleon_footMud_001();
	this.instance.parent = this;
	this.instance.setTransform(4.7,0.7,1,1,0,0,0,3,1.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},1).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#5CFF33").s().p("AgHAIQgHgCgJABQgHABgBgCQgCgEACgEQABgFAVAFIABAAQAVgIANAEQAGACABAEQAAAEgFABQgKADgPAAIgKAAg");
	this.shape.setTransform(5,0.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(1.7,-0.4,6.6,2.3);


(lib.ChameleonFoot_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":90});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-11.6,0.2,0.107,0.107,0,10.2,10,35.1,9.5);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-9.3,-0.7,0.107,0.107,0,10.2,10,35.6,9.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},89).wait(1));

	// Layer 2
	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(1.8,0.2,0.107,0.107,0,10.2,10,35.1,9.5);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(4,-0.7,0.107,0.107,0,10.2,10,35.6,9.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2}]},1).to({state:[]},89).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ChameleonFace_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":90});

	// Layer 3
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(12.2,32,0.577,0.579,0,2.7,2.5,35.5,10.7);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},89).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.Cham = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{rest:0,rest_stop:94,wrongAnswer:96,wet:124,wet_stop:135,"clean":136,clean_stop:148,excited:150,excited_stop:309,tongue:311,animalSound:425});

	// timeline functions:
	this.frame_94 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_122 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_134 = function() {
		/* stop();*/
	}
	this.frame_148 = function() {
		/* stop();*/
	}
	this.frame_308 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}
	this.frame_424 = function() {
		/* stop();*/
	}
	this.frame_486 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(94).call(this.frame_94).wait(28).call(this.frame_122).wait(12).call(this.frame_134).wait(14).call(this.frame_148).wait(160).call(this.frame_308).wait(116).call(this.frame_424).wait(62).call(this.frame_486).wait(8));

	// Nose
	this.instance = new lib.ChameleonNose_1();
	this.instance.parent = this;
	this.instance.setTransform(311.7,107.4,0.28,0.28,51.8);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(311).to({_off:false},0).wait(44).to({rotation:59.2,x:312.4,y:106.5},0).wait(2).to({rotation:66.7,x:313.2,y:105.5},0).wait(2).to({rotation:61.7,x:312.7,y:106.1},0).wait(2).to({rotation:56.7,x:312.1,y:106.8},0).wait(2).to({rotation:51.8,x:311.7,y:107.4},0).wait(2).to({rotation:0,skewX:49.1,skewY:48.9,x:311.5,y:107.8},0).wait(2).to({scaleY:0.28,skewX:46.4,skewY:45.9,x:311.3,y:108.1},0).wait(2).to({scaleY:0.28,skewX:43.5,skewY:43.1,x:311.2,y:108.5},0).wait(2).to({y:108.9},0).wait(19).to({y:108.5},0).wait(2).to({scaleY:0.28,skewX:51.9,skewY:51.4,x:311.8,y:107.6},0).wait(2).to({scaleY:0.28,skewX:60.2,skewY:59.7,x:312.2,y:106.7},0).wait(2).to({skewX:55.9,skewY:55.7,x:312,y:107},0).wait(2).to({rotation:51.8,skewX:0,skewY:0,x:311.7,y:107.4},0).to({_off:true},95).wait(1));

	// Eye
	this.instance_1 = new lib.ChameleonEye_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(315.3,108.7,0.457,0.457,-98.2);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(311).to({_off:false},0).wait(44).to({rotation:-90.8,x:315.8,y:108.3},0).wait(2).to({rotation:-83.3,x:316.3,y:107.8},0).wait(2).to({rotation:-88.4,x:315.9,y:108.1},0).wait(2).to({rotation:-93.3,x:315.6,y:108.4},0).wait(2).to({rotation:-98.2,x:315.3,y:108.7},0).wait(2).to({scaleX:0.46,rotation:-101,x:315.2,y:109},0).wait(2).to({scaleX:0.46,scaleY:0.46,rotation:-103.8,x:315,y:109.1},0).wait(2).to({rotation:0,skewX:-106.5,skewY:-106.8,x:314.9,y:109.4},0).wait(2).to({y:109.6},0).wait(19).to({y:109.4},0).wait(2).to({skewX:-98.1,skewY:-98.5,x:315.2,y:109},0).wait(2).to({skewX:-89.9,skewY:-90.2,x:315.5,y:108.5},0).wait(2).to({scaleX:0.46,scaleY:0.46,rotation:-94,skewX:0,skewY:0,x:315.4,y:108.6},0).wait(2).to({scaleX:0.46,rotation:-98.2,x:315.3,y:108.7},0).to({_off:true},95).wait(1));

	// Head
	this.instance_2 = new lib.ChameleonFace_001();
	this.instance_2.parent = this;
	this.instance_2.setTransform(316,108.2,0.28,0.28,51.8,0,0,16.6,15.6);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(311).to({_off:false},0).wait(44).to({regY:15.8,rotation:59.2,x:316.5,y:107.9},0).wait(2).to({regX:16.8,regY:15.6,rotation:66.7,x:317.1,y:107.5},0).wait(2).to({regY:15.7,rotation:61.7,x:316.7,y:107.8},0).wait(2).to({regX:16.6,regY:15.6,rotation:56.7,x:316.3,y:107.9},0).wait(2).to({rotation:51.8,x:316,y:108.2},0).wait(2).to({regX:16.9,regY:15.8,rotation:0,skewX:49.1,skewY:48.9,x:315.9,y:108.5},0).wait(2).to({regX:16.7,regY:15.6,scaleY:0.28,skewX:46.4,skewY:45.9,x:315.8,y:108.7},0).wait(2).to({regX:17.2,regY:16,scaleY:0.28,skewX:43.5,skewY:43.1,x:315.6,y:108.9},0).wait(2).to({regX:17,regY:15.5,x:315.5,y:109.1},0).wait(19).to({regX:17.2,regY:16,x:315.6,y:108.9},0).wait(2).to({regY:16.1,scaleY:0.28,skewX:51.9,skewY:51.4,x:316,y:108.6},0).wait(2).to({regX:16.7,regY:15.5,scaleY:0.28,skewX:60.2,skewY:59.7,x:316.3,y:108.3},0).wait(2).to({regX:16.9,regY:15.6,skewX:55.9,skewY:55.7,x:316.1},0).wait(2).to({regX:16.6,rotation:51.8,skewX:0,skewY:0,x:316,y:108.2},0).to({_off:true},95).wait(1));

	// Layer 11
	this.instance_3 = new lib.ChameleonTongue_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(315.9,112.4,0.28,0.28,51.8,0,0,16.1,-0.2);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(365).to({_off:false},0).wait(2).to({regX:16,scaleX:0.32,scaleY:0.34,rotation:0,skewX:40.8,skewY:40.3,x:316,y:112.6},0).wait(2).to({regY:-0.1,scaleX:0.37,scaleY:0.4,skewX:29.8,skewY:28.8,x:316.1,y:112.7},0).wait(2).to({regX:16.1,regY:-0.2,scaleX:0.82,scaleY:0.44,skewX:23.1,skewY:22.5,x:316.8,y:113.2},0).wait(1).to({regX:8.2,regY:4.2,scaleX:0.95,scaleY:0.45,skewX:20.8,skewY:19.2,x:309,y:112.6},0).wait(1).to({scaleX:1.05,scaleY:0.46,skewX:19.3,skewY:16.8,x:308.3,y:112.9},0).wait(1).to({scaleX:1.11,scaleY:0.47,skewX:18.3,skewY:15.3,x:307.9,y:113},0).wait(1).to({scaleX:1.15,scaleY:0.47,skewX:17.6,skewY:14.3,x:307.5,y:113.2},0).wait(1).to({scaleX:1.18,scaleY:0.47,skewX:17.1,skewY:13.6,x:307.3},0).wait(1).to({scaleX:1.2,scaleY:0.48,skewX:16.9,skewY:13.2,x:307.2,y:113.3},0).wait(1).to({scaleX:1.21,scaleY:0.48,skewX:16.7,skewY:12.9},0).wait(1).to({scaleX:1.21,scaleY:0.48,skewX:16.6,skewY:12.8,x:307.1,y:113.4},0).wait(1).to({regX:16.1,regY:0,scaleX:1.21,skewX:16.5,skewY:12.7,x:317,y:113.5},0).wait(1).to({regX:8.2,regY:4.2,scaleX:1.21,skewX:16.6,skewY:12.8,x:307.1,y:113.3},0).wait(1).to({scaleX:1.2,scaleY:0.48,skewX:16.9,skewY:13.1,x:307.2},0).wait(1).to({scaleX:1.18,scaleY:0.47,skewX:17.4,skewY:13.7,x:307.3,y:113.2},0).wait(1).to({scaleX:1.14,scaleY:0.47,skewX:18.2,skewY:14.6,x:307.6,y:113.1},0).wait(1).to({scaleX:1.1,scaleY:0.47,skewX:19.3,skewY:15.9,x:307.9,y:112.9},0).wait(1).to({scaleX:1.03,scaleY:0.46,skewX:20.8,skewY:17.6,x:308.4,y:112.7},0).wait(1).to({scaleX:0.94,scaleY:0.45,skewX:23,skewY:20,x:309,y:112.5},0).wait(1).to({scaleX:0.81,scaleY:0.44,skewX:25.9,skewY:23.4,x:309.9,y:112.3},0).wait(1).to({scaleX:0.63,scaleY:0.42,skewX:30.1,skewY:28.2,x:311.1,y:112.2},0).wait(1).to({regX:16,regY:-0.5,scaleX:0.37,scaleY:0.4,skewX:36.2,skewY:35.2,x:316.1,y:112.8},0).to({_off:true},2).wait(102));

	// Layer 12
	this.instance_4 = new lib.ChameleonLowerJaw_001_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(316.4,113,0.28,0.28,51.8,0,0,30.1,3.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(311).to({_off:false},0).wait(44).to({regX:30.2,rotation:59.4,y:112.7},0).wait(2).to({regY:2.9,rotation:67.2,y:112.4},0).wait(2).to({regY:3,rotation:62.2,y:112.6},0).wait(2).to({regX:30.1,rotation:56.9,y:112.8},0).wait(2).to({regY:3.1,rotation:51.8,y:113},0).wait(2).to({regX:29.9,regY:3,scaleX:0.27,scaleY:0.28,rotation:35.8,x:316.6,y:113.2},0).wait(2).to({regX:30.2,regY:3.1,scaleX:0.26,rotation:19.8,x:316.7,y:113.4},0).wait(2).to({regX:30.6,regY:2.9,scaleX:0.24,rotation:0,skewX:4.1,skewY:3.8,x:316.8,y:113.6},0).wait(2).to({regX:30.5,regY:3,x:316.7,y:113.9},0).wait(19).to({regX:30.8,regY:3.2,x:316.8,y:113.3},0).wait(2).to({regX:30.6,regY:3.3,skewX:30.6,skewY:30.3,x:316.7,y:113.2},0).wait(2).to({regX:30.9,regY:2.8,skewX:57,skewY:56.7,x:316.6,y:113.1},0).wait(2).to({regX:31.2,regY:2.7,scaleX:0.26,rotation:54.4,skewX:0,skewY:0},0).wait(2).to({regX:30.1,regY:3.1,scaleX:0.28,scaleY:0.28,rotation:51.8,x:316.4,y:113},0).to({_off:true},95).wait(1));

	// Chameleon Foot C_001
	this.instance_5 = new lib.ChameleonFootC_001();
	this.instance_5.parent = this;
	this.instance_5.setTransform(335.7,123.9,1,1,0,0,0,6.5,1.1);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(311).to({_off:false},0).wait(87).to({_off:true},95).wait(1));

	// Chameleon Leg C Lower_001
	this.instance_6 = new lib.ChameleonLegCLowerLG_001_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(334.9,122.1,0.25,0.25,0,0,0,5.6,4.2);
	this.instance_6._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(311).to({_off:false},0).wait(42).to({regX:5.9,regY:4.4,rotation:-5.2,x:334.8,y:122.4},0).wait(2).to({regX:5.5,rotation:-11.6,x:334.6,y:122.6},0).wait(41).to({regX:5.9,rotation:-5.2,x:334.8,y:122.4},0).wait(2).to({regX:5.6,regY:4.2,rotation:0,x:334.9,y:122.1},0).to({_off:true},95).wait(1));

	// Chameleon Leg C Upper_001
	this.instance_7 = new lib.ChameleonLegCUpperLG_001_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(334.5,118.8,0.25,0.25,3,0,0,0.4,2.8);
	this.instance_7._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(311).to({_off:false},0).wait(42).to({rotation:6.7,x:334.3,y:119.3},0).wait(2).to({regX:0.5,rotation:6,y:119.6},0).wait(41).to({regX:0.4,rotation:6.7,y:119.3},0).wait(2).to({rotation:3,x:334.5,y:118.8},0).to({_off:true},95).wait(1));

	// Chameleon Foot A_001
	this.instance_8 = new lib.ChameleonFootALG_001();
	this.instance_8.parent = this;
	this.instance_8.setTransform(319.5,122.2,0.24,0.24,0,0,0,2.7,1.9);
	this.instance_8._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(311).to({_off:false},0).to({_off:true},182).wait(1));

	// Chameleon Lower Leg A_001
	this.instance_9 = new lib.ChameleonLowerLegALG_001_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(322,121,0.24,0.24,1.8,0,0,1.1,6.5);
	this.instance_9._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(311).to({_off:false},0).wait(42).to({regX:1.2,regY:6.6,rotation:4.5,x:322.1},0).wait(2).to({regX:1,rotation:5,y:121.2},0).wait(37).to({regX:1.1,regY:6.8,rotation:3.7,x:322.2},0).wait(2).to({regX:1.2,regY:6.9,rotation:2.5},0).wait(2).to({rotation:1.3,x:322.1,y:121.1},0).wait(2).to({regX:1.1,regY:6.7,rotation:0.3,x:322,y:121},0).to({_off:true},95).wait(1));

	// Chameleon Leg A Upper_001
	this.instance_10 = new lib.ChameleonLegAUpperLG_001_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(320.8,114.7,0.24,0.24,0,0,0,1.7,1.7);
	this.instance_10._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(311).to({_off:false},0).wait(42).to({regX:1.9,regY:2.2,rotation:-4.9,x:320.9,y:115.1},0).wait(2).to({regY:1.9,rotation:-7.2,x:321.1,y:115.4},0).wait(12).to({regX:2,regY:2,rotation:-8.8,x:321,y:115.6},0).wait(2).to({regX:1.9,rotation:-10.8,y:115.8},0).wait(2).to({regX:2.1,regY:1.9,rotation:-12.6,x:320.8,y:116},0).wait(21).to({regX:2.2,regY:2,rotation:-9.3,x:321,y:115.7},0).wait(2).to({regX:2,regY:2.1,rotation:-6.3,y:115.5},0).wait(2).to({regX:2.1,regY:2.2,rotation:-3.3,y:115.2},0).wait(2).to({regX:2.3,regY:1.9,rotation:-0.4,y:114.8},0).to({_off:true},95).wait(1));

	// Chameleon Back Ridge
	this.instance_11 = new lib.ChameleonBackRidge_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(330.2,112.5,0.249,0.249,6.8);
	this.instance_11._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(311).to({_off:false},0).wait(42).to({rotation:0,skewX:6.8,skewY:8,x:329.9,y:112.9},0).wait(2).to({skewY:9.6,x:329.7,y:113.1},0).wait(2).to({skewY:9.5},0).wait(6).to({skewY:9.6},0).wait(2).to({scaleX:0.25,skewY:9,y:113.2},0).wait(2).to({scaleX:0.25,skewY:8.5},0).wait(2).to({scaleX:0.25,skewY:8,x:329.6,y:113.3},0).wait(2).to({scaleX:0.25,scaleY:0.25,skewX:6.9,skewY:7.6,x:329.5,y:113.4},0).wait(21).to({scaleX:0.25,scaleY:0.25,skewX:6.8,skewY:8.5,x:329.6,y:113.2},0).wait(2).to({scaleX:0.25,skewY:9.6,x:329.7,y:113.1},0).wait(2).to({skewY:8,x:330,y:112.8},0).wait(2).to({rotation:6.8,skewX:0,skewY:0,x:330.2,y:112.5},0).to({_off:true},95).wait(1));

	// Chameleon Torso New
	this.instance_12 = new lib.ChameleonTorsoNew();
	this.instance_12.parent = this;
	this.instance_12.setTransform(321.8,111.7,0.249,0.249,6.8,0,0,-26.8,-9.3);
	this.instance_12._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_12).wait(311).to({_off:false},0).wait(42).to({regX:-26.7,regY:-9.6,scaleY:0.25,rotation:0,skewX:6.8,skewY:7.8,y:111.8},0).wait(2).to({regX:-26.8,regY:-9.3,scaleX:0.25,skewY:9.1,y:111.9},0).wait(2).to({scaleY:0.25,skewY:9,y:112},0).wait(6).to({scaleY:0.25,skewY:9.1,y:111.9},0).wait(2).to({regX:-26.9,regY:-9.4,scaleX:0.25,skewY:8.5,x:321.6,y:112.1},0).wait(2).to({regY:-9.3,scaleX:0.25,skewY:8,y:112.2},0).wait(2).to({regX:-27.7,regY:-2.1,scaleX:0.25,skewY:7.5,x:321,y:114.1},0).wait(2).to({regX:-26.8,regY:-9.3,scaleX:0.26,scaleY:0.25,skewX:6.9,skewY:7.1,x:321.3,y:112.5},0).wait(21).to({regX:-27.3,regY:-9.2,scaleX:0.25,scaleY:0.25,skewX:6.8,skewY:8,x:321.4,y:112.3},0).wait(2).to({regX:-26.8,regY:-9.3,scaleX:0.25,skewY:9.1,x:321.8,y:111.9},0).wait(2).to({scaleX:0.25,skewY:7.8},0).wait(2).to({scaleY:0.25,rotation:6.8,skewX:0,skewY:0,y:111.7},0).to({_off:true},95).wait(1));

	// Chameleon Tail New
	this.instance_13 = new lib.ChameleonTailNew();
	this.instance_13.parent = this;
	this.instance_13.setTransform(339.5,117,0.249,0.249,0,0,0,-37.8,14.5);
	this.instance_13._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(311).to({_off:false},0).wait(42).to({regY:21.6,skewY:1.1,x:339.6,y:119.3},0).wait(2).to({regY:14.5,skewY:2.4,x:339.5,y:118},0).wait(2).to({regY:14.3,skewY:2.3},0).wait(6).to({regY:14.5,skewY:2.4},0).wait(2).to({regX:-38,regY:14.4,skewX:-1.6,skewY:0.5,y:117.9},0).wait(2).to({regX:-37.8,regY:14.7,skewX:-3.3,skewY:-1},0).wait(2).to({regX:-37.6,regY:14.3,skewX:-5.1,skewY:-2.8,x:339.4,y:117.8},0).wait(2).to({regY:14.4,skewX:-7,skewY:-4.6,y:117.7},0).wait(21).to({regX:-37.4,regY:14.2,skewX:-3.3,skewY:-1,x:339.5,y:117.8},0).wait(2).to({regX:-37.8,regY:14.5,skewX:0,skewY:2.4,y:118},0).wait(2).to({regY:21.6,skewY:1.1,x:339.6,y:119.3},0).wait(2).to({regY:14.5,skewY:0,x:339.5,y:117},0).to({_off:true},95).wait(1));

	// Chameleon Foot B_001
	this.instance_14 = new lib.ChameleonFootBLG_001();
	this.instance_14.parent = this;
	this.instance_14.setTransform(318.5,121.6,0.24,0.24,0,0,0,2.5,1.9);
	this.instance_14._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_14).wait(311).to({_off:false},0).to({_off:true},182).wait(1));

	// Chameleon Leg B Lower_001
	this.instance_15 = new lib.ChameleonLegBLowerLG_001_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(320.8,120,0.24,0.24,-0.7,0,0,1,5.9);
	this.instance_15._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_15).wait(311).to({_off:false},0).wait(42).to({regX:1.2,regY:6,rotation:0.1,x:321.1},0).wait(2).to({regX:1.1,rotation:5.8,x:321.2,y:120.1},0).wait(41).to({rotation:2.6},0).wait(2).to({regX:1.2,regY:5.9,rotation:-0.4,y:120},0).to({_off:true},95).wait(1));

	// Chameleon Leg B Upper_001
	this.instance_16 = new lib.ChameleonLegBUpperLG__1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(320.1,114.2,0.24,0.24,0,0,0,2.7,3.4);
	this.instance_16._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_16).wait(311).to({_off:false},0).to({_off:true},182).wait(1));

	// Chameleon Foot D_001
	this.instance_17 = new lib.ChameleonFootDLG_001();
	this.instance_17.parent = this;
	this.instance_17.setTransform(332.9,122.6,0.24,0.24,0,0,0,4.8,1.1);
	this.instance_17._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_17).wait(311).to({_off:false},0).to({_off:true},182).wait(1));

	// Chameleon Leg D Lower_001
	this.instance_18 = new lib.ChameleonLegDLowerLG_001_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(333.5,121.8,0.24,0.24,-1.8,0,0,5.5,4.2);
	this.instance_18._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_18).wait(311).to({_off:false},0).wait(42).to({regY:4.3,rotation:-7.3,y:121.9},0).wait(2).to({regY:4.2,rotation:-9.1},0).wait(41).to({regX:5.7,regY:4.1,rotation:-5.6,x:333.6,y:121.8},0).wait(2).to({regY:4.2,rotation:-2.4},0).to({_off:true},95).wait(1));

	// Chameleon Leg D Upper_001
	this.instance_19 = new lib.ChameleonLegDUpperLG_001_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(333.8,118.2,0.24,0.24,0,0,0,3.8,2.5);
	this.instance_19._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_19).wait(311).to({_off:false},0).to({_off:true},182).wait(1));

	// sparkle
	this.instance_20 = new lib.sparkle();
	this.instance_20.parent = this;
	this.instance_20.setTransform(349,114.4,0.245,0.245);
	this.instance_20._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_20).wait(301).to({_off:false},0).to({_off:true},10).wait(183));

	// sparkle
	this.instance_21 = new lib.sparkle();
	this.instance_21.parent = this;
	this.instance_21.setTransform(321.8,111.7,0.245,0.245);
	this.instance_21._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_21).wait(292).to({_off:false},0).to({_off:true},19).wait(183));

	// Chameleon Face_001
	this.mouth_bubbles = new lib.ChameleonFace_001_bubbles();
	this.mouth_bubbles.parent = this;
	this.mouth_bubbles.setTransform(316,108.2,0.28,0.28,51.8,0,0,16.6,15.6);

	this.timeline.addTween(cjs.Tween.get(this.mouth_bubbles).to({_off:true},124).wait(187).to({_off:false},0).to({_off:true},182).wait(1));

	// Chameleon Torso New
	this.back_bubbles = new lib.ChameleonTorsoNew_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(321.8,111.7,0.249,0.249,6.8,0,0,-26.8,-9.3);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).to({_off:true},124).wait(187).to({_off:false},0).to({_off:true},182).wait(1));

	// Chameleon Tail New
	this.tail_bubbles = new lib.ChameleonTailNew_bubbles();
	this.tail_bubbles.parent = this;
	this.tail_bubbles.setTransform(339.5,117,0.249,0.249,0,0,0,-37.8,14.5);

	this.timeline.addTween(cjs.Tween.get(this.tail_bubbles).to({_off:true},124).wait(187).to({_off:false},0).to({_off:true},182).wait(1));

	// Chameleon Foot Mud
	this.feet_bubbles = new lib.ChameleonFoot_bubbles();
	this.feet_bubbles.parent = this;
	this.feet_bubbles.setTransform(335.7,123.9,1,1,0,0,0,6.5,1.1);

	this.timeline.addTween(cjs.Tween.get(this.feet_bubbles).to({_off:true},124).wait(187).to({_off:false},0).to({_off:true},182).wait(1));

	// sparkle
	this.instance_22 = new lib.sparkle();
	this.instance_22.parent = this;
	this.instance_22.setTransform(333.8,118.2,0.325,0.325);
	this.instance_22._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_22).wait(274).to({_off:false},0).to({_off:true},37).wait(183));

	// yellow
	this.instance_23 = new lib.green_chameleon4_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(329.2,116.8);
	this.instance_23.alpha = 0;
	this.instance_23._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_23).wait(216).to({_off:false},0).to({alpha:1},10).wait(8).to({alpha:0},20).to({_off:true},1).wait(239));

	// blue
	this.instance_24 = new lib.green_chameleon3_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(329.2,116.8);
	this.instance_24.alpha = 0;
	this.instance_24._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_24).wait(198).to({_off:false},0).to({alpha:1},10).to({_off:true},18).wait(268));

	// pink
	this.instance_25 = new lib.green_chameleon2_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(329.2,116.8);
	this.instance_25.alpha = 0;
	this.instance_25._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_25).wait(182).to({_off:false},0).to({alpha:1},10).to({_off:true},16).wait(286));

	// green
	this.instance_26 = new lib.green_chameleon_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(329.2,116.8);
	this.instance_26._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_26).wait(180).to({_off:false},0).to({_off:true},12).wait(42).to({_off:false},0).to({_off:true},30).wait(230));

	// Layer 2
	this.instance_27 = new lib.water_drops_009();
	this.instance_27.parent = this;
	this.instance_27.setTransform(333,117.3,0.2,0.2,0,0,180,92.4,49.2);

	this.instance_28 = new lib.chameleonhead_excited_001_overlay_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(318.4,115.4,1,1,-63.2,0,0,9.1,10.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_27}]},124).to({state:[]},12).to({state:[{t:this.instance_28}]},36).to({state:[]},8).to({state:[]},313).wait(1));

	// Nose
	this.instance_29 = new lib.ChameleonNose_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(311.7,107.4,0.28,0.28,51.8);

	this.instance_30 = new lib.chameleonhead_excited_001_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(318.4,111.9,1,1,0,0,0,9.2,10.1);
	this.instance_30._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_29).wait(14).to({rotation:53.7,x:311.9,y:107.1},0).wait(2).to({rotation:55.7,x:312,y:106.8},0).wait(2).to({x:312.1,y:106.9},0).wait(10).to({x:312,y:106.8},0).wait(2).to({rotation:53.7,x:311.9,y:107.1},0).wait(2).to({rotation:51.8,x:311.7,y:107.4},0).wait(2).to({rotation:50.7,x:311.6,y:107.5},0).wait(2).to({rotation:49.6,x:311.5,y:107.7},0).wait(2).to({rotation:48.6,x:311.4,y:107.8},0).wait(26).to({rotation:49.6,x:311.5,y:107.7},0).wait(2).to({rotation:50.7,x:311.6,y:107.5},0).wait(2).to({rotation:51.8,x:311.7,y:107.4},0).wait(2).to({rotation:52.4,y:107.3},0).wait(2).to({rotation:53.1,y:107.2},0).wait(2).to({rotation:53.7,x:311.8},0).wait(2).to({rotation:52.7,x:311.7,y:107.3},0).wait(2).to({rotation:51.8,y:107.4},0).wait(22).to({rotation:53.7,x:311.9,y:107.1},0).wait(2).to({rotation:55.7,x:312,y:106.8},0).wait(6).to({rotation:53.7,x:311.9,y:107.1},0).wait(2).to({rotation:51.8,x:311.7,y:107.4},0).wait(26).to({_off:true},14).wait(344));
	this.timeline.addTween(cjs.Tween.get(this.instance_30).wait(150).to({_off:false},0).wait(12).to({regX:9.1,regY:8.8,rotation:7.3,x:319.5,y:110.1},0).wait(2).to({regX:9.6,regY:9.8,rotation:15,x:320.5,y:110.8},0).wait(2).to({regX:12.5,regY:8.6,rotation:-4.5,x:322.8,y:110.4},0).wait(2).to({regX:9.3,regY:10,scaleX:1,scaleY:1,rotation:-24.1,x:319.3,y:113.2},0).wait(2).to({regX:9.6,regY:9.8,scaleX:1,scaleY:1,rotation:-43.6,x:318.9,y:114.2},0).wait(2).to({regX:9.1,regY:10.1,scaleX:1,scaleY:1,rotation:-63.2,x:318.4,y:115.4},0).to({_off:true},8).wait(84).to({_off:false,scaleX:1,scaleY:1,rotation:-43.6,x:318.9,y:114.2},0).wait(2).to({scaleX:1,scaleY:1,rotation:-24.1,x:319.4,y:113.1},0).wait(2).to({regX:11.7,regY:12.2,scaleX:1,scaleY:1,rotation:-4.5,x:322.7,y:113.9},0).wait(2).to({regX:9.6,regY:9.8,rotation:15,x:320.5,y:110.8},0).wait(2).to({regX:11.2,regY:8.8,rotation:7.3,x:321.2,y:110.4},0).wait(2).to({regX:9.2,regY:10.1,rotation:0,x:318.4,y:111.9},0).to({_off:true},37).wait(183));

	// Eye
	this.cham_head = new lib.ChameleonEye_1();
	this.cham_head.parent = this;
	this.cham_head.setTransform(315.3,108.7,0.457,0.457,-98.2);

	this.timeline.addTween(cjs.Tween.get(this.cham_head).wait(14).to({rotation:-96.3,x:315.4,y:108.6},0).wait(2).to({rotation:-94.3,x:315.5,y:108.4},0).wait(14).to({rotation:-96.3,x:315.4,y:108.6},0).wait(2).to({rotation:-98.2,x:315.3,y:108.7},0).wait(2).to({rotation:-99.3},0).wait(2).to({rotation:-100.3,x:315.1,y:108.8},0).wait(2).to({rotation:-101.4,y:108.9},0).wait(26).to({rotation:-100.3,x:315.2,y:108.8},0).wait(2).to({rotation:-99.3},0).wait(2).to({rotation:-98.2,x:315.3,y:108.7},0).wait(2).to({rotation:-97.5,x:315.4},0).wait(2).to({rotation:-96.8,y:108.6},0).wait(2).to({rotation:-96.3,y:108.5},0).wait(2).to({rotation:-97.3,y:108.6},0).wait(2).to({rotation:-98.2,x:315.3,y:108.7},0).wait(22).to({rotation:-96.3,x:315.4,y:108.6},0).wait(2).to({rotation:-94.3,x:315.5,y:108.4},0).wait(6).to({rotation:-96.3,x:315.4,y:108.6},0).wait(2).to({rotation:-98.2,x:315.3,y:108.7},0).wait(26).to({_off:true},14).wait(344));

	// Head
	this.cham_head_1 = new lib.ChameleonFace_001();
	this.cham_head_1.parent = this;
	this.cham_head_1.setTransform(316,108.2,0.28,0.28,51.8,0,0,16.6,15.6);

	this.timeline.addTween(cjs.Tween.get(this.cham_head_1).wait(14).to({regY:15.8,rotation:53.7,x:316.1},0).wait(2).to({regX:16.8,regY:15.6,rotation:55.7,x:316.3,y:108.1},0).wait(2).to({regX:16.9,regY:15.7,x:316.2},0).wait(10).to({regX:16.8,regY:15.6,x:316.3},0).wait(2).to({regX:16.6,regY:15.5,rotation:53.7,x:316.1},0).wait(2).to({regY:15.6,rotation:51.8,x:316,y:108.2},0).wait(2).to({regY:15.5,rotation:50.7},0).wait(2).to({regY:15.6,rotation:49.6,x:315.9,y:108.3},0).wait(2).to({regY:15.2,rotation:48.6,y:108.4},0).wait(26).to({rotation:49.6,y:108.3},0).wait(2).to({rotation:50.7,y:108.2},0).wait(2).to({regY:15.6,rotation:51.8,x:316},0).wait(2).to({regX:16.4,rotation:52.4},0).wait(2).to({regX:16.5,regY:15.5,rotation:53.1,x:316.1,y:108.1},0).wait(2).to({regX:16.7,regY:15.6,rotation:53.7,x:316.2},0).wait(2).to({regX:16.9,rotation:52.7,x:316.1,y:108.2},0).wait(2).to({regX:16.6,rotation:51.8,x:316},0).wait(22).to({regY:15.8,rotation:53.7,x:316.1},0).wait(2).to({regX:16.8,regY:15.6,rotation:55.7,x:316.3,y:108.1},0).wait(6).to({regX:16.6,regY:15.8,rotation:53.7,x:316.1,y:108.2},0).wait(2).to({regY:15.6,rotation:51.8,x:316},0).wait(26).to({_off:true},14).wait(344));

	// Layer 6
	this.instance_31 = new lib.ChameleonLowerJaw_001_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(316.4,113,0.28,0.28,51.8,0,0,30.1,3.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_31).wait(14).to({rotation:53.9,x:316.5},0).wait(2).to({regX:30.2,regY:2.8,rotation:56.2},0).wait(2).to({regY:2.9},0).wait(10).to({regY:2.8},0).wait(2).to({regX:30.3,regY:2.9,rotation:53.9},0).wait(2).to({regX:30.1,regY:3.1,rotation:51.8,x:316.4},0).wait(2).to({regX:29.9,regY:2.9,rotation:42.6,x:316.5,y:112.9},0).wait(2).to({regX:30.2,regY:3,rotation:33.3,x:316.6,y:113},0).wait(2).to({regY:2.6,rotation:24.2,x:316.5},0).wait(26).to({regX:29.9,regY:2.5,rotation:33.3},0).wait(2).to({regX:30.1,regY:2.7,rotation:42.6},0).wait(2).to({regY:3.1,rotation:51.8,x:316.4},0).wait(2).to({regX:30.2,rotation:52.6},0).wait(2).to({rotation:53.4,x:316.6,y:113.1},0).wait(2).to({regX:29.9,rotation:54.2,x:316.5},0).wait(2).to({regX:30.1,regY:3.2,rotation:52.9},0).wait(2).to({regY:3.1,rotation:51.8,x:316.4,y:113},0).wait(22).to({rotation:53.9,x:316.5},0).wait(2).to({regX:30.2,regY:2.8,rotation:56.2},0).wait(6).to({regX:30.1,regY:3.1,rotation:53.9},0).wait(2).to({rotation:51.8,x:316.4},0).wait(26).to({_off:true},14).wait(344));

	// Chameleon Foot C_001
	this.cham_hindleg = new lib.ChameleonFootCLG_001();
	this.cham_hindleg.parent = this;
	this.cham_hindleg.setTransform(334.5,123.6,0.25,0.25,0,0,0,6.6,1.2);

	this.timeline.addTween(cjs.Tween.get(this.cham_hindleg).wait(172).to({_off:true},8).wait(84).to({_off:false},0).wait(10).to({_off:true},37).wait(183));

	// Chameleon Leg C Lower_001
	this.instance_32 = new lib.ChameleonLegCLowerLG_001_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(334.9,122.1,0.25,0.25,0,0,0,5.6,4.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_32).wait(14).to({regX:6,regY:4.4,rotation:-5.7,y:122.4},0).wait(2).to({regX:5.6,regY:4.5,rotation:-11.9,x:334.7,y:122.6},0).wait(14).to({regX:5.8,regY:4.6,rotation:-5.9,x:334.9,y:122.3},0).wait(2).to({regX:6,regY:4.8,rotation:1.8,x:335},0).wait(4).to({regX:6.4,regY:5.2,rotation:-7.4,y:122.6},0).wait(2).to({regX:5.9,regY:4.8,rotation:-12.7,x:334.8,y:122.7},0).wait(32).to({regX:6,regY:5,rotation:-10,x:335},0).wait(2).to({regY:4.9,rotation:-7.5,x:334.9,y:122.5},0).wait(2).to({regY:5,rotation:-5,y:122.4},0).wait(2).to({regY:4.9,rotation:-2.5,y:122.2},0).wait(2).to({regX:5.6,regY:4.2,rotation:0,y:122.1},0).wait(22).to({regX:5.8,rotation:-6.3,y:122.5},0).wait(2).to({regX:5.9,regY:4.8,rotation:-12.7,x:334.8,y:122.7},0).wait(6).to({regX:5.8,regY:4.2,rotation:-6.3,x:334.9,y:122.5},0).wait(2).to({regX:5.6,rotation:0,y:122.1},0).wait(54).to({x:335.1,y:122.3},0).wait(2).to({x:334.9,y:122.2},0).wait(2).to({x:334.7,y:122},0).wait(2).to({x:334.5,y:121.9},0).wait(2).to({x:334.3,y:121.7},0).to({_off:true},8).wait(84).to({_off:false,regX:5.8,regY:4.4,scaleX:0.25,skewX:0.5,skewY:-1.5,x:334.5,y:121.9},0).wait(2).to({regX:5.9,regY:4.3,scaleX:0.24,scaleY:0.25,skewX:1.3,skewY:-3.3,x:334.7,y:122},0).wait(2).to({regX:5.7,regY:4.9,scaleX:0.24,skewX:1.9,skewY:-5.2,y:122.2},0).wait(2).to({regY:5.1,scaleX:0.24,skewX:1.1,skewY:-3.3,x:334.8},0).wait(2).to({regX:5.5,regY:5,scaleX:0.25,scaleY:0.25,skewX:0.5,skewY:-1.6},0).wait(2).to({regX:5.6,regY:4.2,scaleX:0.25,skewX:0,skewY:0,x:334.9,y:122.1},0).to({_off:true},37).wait(183));

	// Chameleon Leg C Upper_001
	this.instance_33 = new lib.ChameleonLegCUpperLG_001_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(334.5,118.8,0.25,0.25,3,0,0,0.4,2.8);

	this.timeline.addTween(cjs.Tween.get(this.instance_33).wait(14).to({regX:0.6,rotation:3.3,x:334.1,y:119.3},0).wait(2).to({regX:0.2,regY:3,rotation:4.9,x:334.4,y:119.7},0).wait(14).to({regX:0.5,regY:3.1,rotation:8.4,x:334.7,y:119.2},0).wait(2).to({x:334.3,y:118.8},0).wait(4).to({x:334.2,y:119.4},0).wait(2).to({regX:0.8,regY:3.4,rotation:6,x:334.4,y:119.9},0).wait(32).to({regX:0.9,rotation:5.3,x:334.5},0).wait(2).to({regX:0.8,rotation:4.5,x:334.6,y:119.6},0).wait(2).to({rotation:4,y:119.4},0).wait(2).to({regY:3.6,rotation:3.5,y:119.1},0).wait(2).to({regX:0.4,regY:2.8,rotation:3,x:334.5,y:118.8},0).wait(22).to({regX:0.5,regY:3,rotation:4.3,y:119.5},0).wait(2).to({regX:0.8,regY:3.4,rotation:6,x:334.4,y:119.9},0).wait(6).to({regX:0.5,regY:3,rotation:4.3,x:334.5,y:119.5},0).wait(2).to({regX:0.4,regY:2.8,rotation:3,y:118.8},0).wait(54).to({x:334.9},0).wait(2).to({regX:0.3,scaleX:0.25,rotation:0,skewX:1.8,skewY:2.3,x:334.6,y:118.7},0).wait(2).to({regX:0.5,scaleX:0.25,skewX:0.8,skewY:1.8,x:334.1,y:118.4},0).wait(2).to({regX:0.4,scaleX:0.24,skewX:0,skewY:1.3,x:333.7,y:118.2},0).wait(2).to({regY:3,scaleX:0.24,skewX:-1.2,skewY:0.7,x:333.3,y:118},0).to({_off:true},8).wait(84).to({_off:false,regY:3.2,skewX:-0.3,skewY:1.5,x:333.6,y:118.5},0).wait(2).to({regX:0.2,regY:3,skewX:0.5,skewY:2.5,x:333.9,y:118.8},0).wait(2).to({regX:0.3,skewX:1.6,skewY:3.5,x:334.3,y:119.1},0).wait(2).to({regX:0.5,regY:3.2,scaleX:0.24,skewX:2,skewY:3.3,x:334.4},0).wait(2).to({regX:0.4,regY:3,scaleX:0.25,skewX:2.5,skewY:3,x:334.5,y:118.9},0).wait(2).to({regY:2.8,scaleX:0.25,rotation:3,skewX:0,skewY:0,y:118.8},0).to({_off:true},37).wait(183));

	// Chameleon Foot A_001
	this.cham_frontleg = new lib.ChameleonFootALG_001();
	this.cham_frontleg.parent = this;
	this.cham_frontleg.setTransform(319.5,122.2,0.24,0.24,0,0,0,2.7,1.9);

	this.timeline.addTween(cjs.Tween.get(this.cham_frontleg).wait(172).to({_off:true},8).wait(84).to({_off:false},0).to({_off:true},47).wait(183));

	// Chameleon Lower Leg A_001
	this.instance_34 = new lib.ChameleonLowerLegALG_001_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(322,121,0.24,0.24,1.8,0,0,1.1,6.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_34).wait(16).to({regY:6.4,rotation:6,x:322.2,y:121.2},0).wait(14).to({regX:1.2,regY:6.5,rotation:1.1,x:322,y:121},0).wait(2).to({regX:1.3,regY:6.7,rotation:-1.4},0).wait(2).to({regX:1.4,regY:6.9,rotation:1.3,x:322.1,y:121.1},0).wait(2).to({regX:1.5,regY:7,rotation:3.8,x:322.2,y:121.2},0).wait(2).to({regX:1.1,regY:6.6,rotation:5.3},0).wait(32).to({regX:1.2,regY:6.8,rotation:4.5,y:121.3},0).wait(2).to({regY:6.6,rotation:3.8,y:121.2},0).wait(2).to({rotation:3,x:322.1},0).wait(2).to({regX:1.1,regY:6.7,rotation:2.3,y:121.1},0).wait(2).to({regY:6.5,rotation:1.8,x:322,y:121},0).wait(24).to({regY:6.6,rotation:5.5,x:322.1,y:121.2},0).wait(6).to({regY:6.5,rotation:1.8,x:322,y:121},0).wait(2).to({rotation:1.8},0).wait(52).to({regX:1.4,regY:6.8,rotation:-9.6,x:322.1,y:120.6},0).wait(2).to({regY:7.2,rotation:-17.6,x:321.7,y:121},0).wait(2).to({regX:1.5,regY:7.4,rotation:-12.8,x:322,y:121.2},0).wait(2).to({regX:1.4,rotation:-8.3},0).wait(2).to({regX:1.6,regY:7.2,rotation:-3.8},0).wait(2).to({regY:7.5,rotation:0.8,x:322.1,y:121.4},0).to({_off:true},8).wait(84).to({_off:false,regX:1.7,regY:7.4,rotation:-3.6,y:121.3},0).wait(2).to({rotation:-8.3,x:322,y:121.2},0).wait(2).to({regX:1.5,regY:7.6,rotation:-12.8,x:321.9,y:121.1},0).wait(2).to({regX:1.9,regY:7.8,rotation:-17.4,x:321.8,y:121},0).wait(2).to({regY:7.9,rotation:-7.8,x:322,y:121.1},0).wait(2).to({regX:1.1,regY:6.5,rotation:1.8,y:121},0).to({_off:true},37).wait(183));

	// Chameleon Leg A Upper_001
	this.instance_35 = new lib.ChameleonLegAUpperLG_001_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(320.8,114.7,0.24,0.24,0,0,0,1.7,1.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_35).wait(14).to({regX:1.9,rotation:-1.4,x:321,y:115},0).wait(2).to({regY:1.9,rotation:-6.9,x:321.1,y:115.4},0).wait(14).to({x:320.8,y:115.5},0).wait(2).to({regY:2.3,rotation:-11.1,x:320.9,y:115.6},0).wait(2).to({x:321.1},0).wait(2).to({regY:2.6,rotation:-9.7},0).wait(2).to({regY:1.8,rotation:-4.4,y:115.2},0).wait(32).to({regY:2,rotation:-3.3},0).wait(2).to({regX:2,regY:1.9,rotation:-2.5,y:115.1},0).wait(2).to({rotation:-1.5,x:321,y:115},0).wait(2).to({rotation:-0.8,x:320.9,y:114.9},0).wait(2).to({regX:1.7,regY:1.7,rotation:0,x:320.8,y:114.7},0).wait(22).to({regX:1.8,regY:1.8,rotation:-2.5,x:320.9,y:115},0).wait(2).to({regX:1.9,regY:1.9,rotation:-5.6,x:321.1,y:115.4},0).wait(6).to({regX:1.8,regY:1.8,rotation:-2.5,x:320.9,y:115},0).wait(2).to({regX:1.7,regY:1.7,rotation:0,x:320.8,y:114.7},0).wait(52).to({regX:1.8,regY:2,rotation:9.6,x:321.3,y:114.4},0).wait(2).to({regX:2,regY:1.7,rotation:22.5,x:321.6},0).wait(2).to({regY:1.8,rotation:16.8,y:114.5},0).wait(2).to({rotation:11.1,x:321.4,y:114.6},0).wait(2).to({regX:2.2,regY:1.7,rotation:5.5,x:321.3,y:114.7},0).wait(2).to({regX:2.3,rotation:0,x:321.1,y:114.8},0).to({_off:true},8).wait(84).to({_off:false,regX:2.2,rotation:5.5,x:321.4,y:114.7},0).wait(2).to({regX:2.5,regY:1.9,rotation:11.1,x:321.6,y:114.6},0).wait(2).to({regY:1.7,rotation:16.8,x:321.7,y:114.4},0).wait(2).to({rotation:22.5,x:321.8,y:114.3},0).wait(2).to({regX:2.7,regY:1.8,rotation:11.1,x:321.3,y:114.4},0).wait(2).to({regX:1.7,regY:1.7,rotation:0,x:320.8,y:114.7},0).to({_off:true},37).wait(183));

	// Chameleon Back Ridge
	this.cham_back = new lib.ChameleonBackRidge_1();
	this.cham_back.parent = this;
	this.cham_back.setTransform(330.2,112.5,0.249,0.249,6.8);

	this.timeline.addTween(cjs.Tween.get(this.cham_back).wait(14).to({rotation:0,skewX:6.8,skewY:8,x:329.9,y:112.9},0).wait(2).to({skewY:9.6,x:329.7,y:113.1},0).wait(2).to({skewY:9.5},0).wait(10).to({skewY:9.6},0).wait(2).to({skewX:5.8,skewY:8.8,x:329.8,y:113},0).wait(2).to({skewX:5.1,skewY:7.9,y:112.8},0).wait(2).to({skewX:5.5,skewY:8.3,y:112.9},0).wait(2).to({skewX:6.1,skewY:9,x:329.7,y:113},0).wait(2).to({skewX:6.8,skewY:9.6,y:113.1},0).wait(26).to({skewY:9.5},0).wait(4).to({skewY:9.6},0).wait(2).to({skewY:9,x:329.8,y:113},0).wait(2).to({skewY:8.3,x:330,y:112.9},0).wait(2).to({skewY:7.8,y:112.7},0).wait(2).to({skewY:7.3,x:330.1,y:112.6},0).wait(2).to({rotation:6.8,skewX:0,skewY:0,x:330.2,y:112.5},0).wait(22).to({rotation:0,skewX:6.8,skewY:8,x:329.9,y:112.9},0).wait(2).to({skewY:9.6,x:329.7,y:113.1},0).wait(6).to({skewY:8,x:329.9,y:112.9},0).wait(2).to({rotation:6.8,skewX:0,skewY:0,x:330.2,y:112.5},0).wait(26).to({_off:true},14).wait(344));

	// Chameleon Torso New
	this.instance_36 = new lib.ChameleonTorso_Excited_003_overlay_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(339.9,116.1,0.249,0.249,6.8,0,0,47.8,-0.4);
	this.instance_36._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_36).wait(172).to({_off:false},0).to({_off:true},8).wait(314));

	// Chameleon Torso New
	this.cham_back_1 = new lib.ChameleonTorsoNew();
	this.cham_back_1.parent = this;
	this.cham_back_1.setTransform(321.8,111.7,0.249,0.249,6.8,0,0,-26.8,-9.3);

	this.cham_back_2 = new lib.ChameleonTorso_Excited_001_1();
	this.cham_back_2.parent = this;
	this.cham_back_2.setTransform(339.9,116.1,0.249,0.249,6.8,0,0,47.8,-0.4);
	this.cham_back_2._off = true;

	this.cham_back_3 = new lib.ChameleonTorso_Excited_003_1();
	this.cham_back_3.parent = this;
	this.cham_back_3.setTransform(339.9,116.1,0.249,0.249,6.8,0,0,47.8,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.cham_back_1}]}).to({state:[{t:this.cham_back_1}]},14).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},24).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},22).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},6).to({state:[{t:this.cham_back_1}]},2).to({state:[{t:this.cham_back_1}]},26).to({state:[{t:this.cham_back_2}]},14).to({state:[{t:this.cham_back_2}]},12).to({state:[{t:this.cham_back_2}]},2).to({state:[{t:this.cham_back_2}]},2).to({state:[{t:this.cham_back_2}]},2).to({state:[{t:this.cham_back_2}]},2).to({state:[{t:this.cham_back_3}]},2).to({state:[]},8).to({state:[{t:this.cham_back_2}]},84).to({state:[{t:this.cham_back_2}]},2).to({state:[{t:this.cham_back_2}]},2).to({state:[{t:this.cham_back_2}]},2).to({state:[{t:this.cham_back_2}]},2).to({state:[{t:this.cham_back_2}]},2).to({state:[]},37).to({state:[]},182).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.cham_back_1).wait(14).to({regX:-26.7,regY:-9.6,scaleY:0.25,rotation:0,skewX:6.8,skewY:7.8,y:111.8},0).wait(2).to({regX:-26.8,regY:-9.3,scaleX:0.25,skewY:9.1,y:111.9},0).wait(2).to({scaleY:0.25,skewY:9,y:112},0).wait(10).to({scaleY:0.25,skewY:9.1,y:111.9},0).wait(2).to({regX:-24.9,scaleY:0.25,skewX:5.8,skewY:8.3,x:322.3,y:112},0).wait(2).to({regX:-26.9,regY:-9.2,scaleY:0.25,skewX:5.1,skewY:7.4,x:321.8,y:111.9},0).wait(2).to({regX:-28.2,regY:-9.1,scaleY:0.25,skewX:5.5,skewY:7.8,x:321.5,y:111.8},0).wait(2).to({regX:-26.9,regY:-9.3,skewX:6.1,skewY:8.5,x:321.8,y:111.9},0).wait(2).to({regX:-26.8,scaleY:0.25,skewX:6.8,skewY:9.1},0).wait(26).to({scaleY:0.25,skewY:9,y:112},0).wait(4).to({scaleY:0.25,skewY:9.1,y:111.9},0).wait(2).to({regY:-9.4,skewY:8.5},0).wait(2).to({regY:-9.2,skewY:8,x:321.7,y:111.8},0).wait(2).to({regX:-26.7,regY:-9.7,scaleX:0.25,skewY:7.6,x:321.9,y:111.7},0).wait(2).to({regX:-25.5,regY:-10.4,skewY:7.1,x:322.1,y:111.5},0).wait(2).to({regX:-26.8,regY:-9.3,scaleY:0.25,rotation:6.8,skewX:0,skewY:0,x:321.8,y:111.7},0).wait(22).to({regX:-26.7,regY:-9.6,scaleY:0.25,rotation:0,skewX:6.8,skewY:7.8,y:111.8},0).wait(2).to({regX:-26.8,regY:-9.3,scaleX:0.25,skewY:9.1,y:111.9},0).wait(6).to({regX:-26.7,regY:-9.6,scaleX:0.25,skewY:7.8,y:111.8},0).wait(2).to({regX:-26.8,regY:-9.3,scaleY:0.25,rotation:6.8,skewX:0,skewY:0,y:111.7},0).wait(26).to({_off:true},14).wait(344));
	this.timeline.addTween(cjs.Tween.get(this.cham_back_2).wait(150).to({_off:false},0).wait(12).to({regX:47.7,regY:-0.5,rotation:8.5,y:116},0).wait(2).to({regX:47.8,rotation:10.5,y:116.1},0).wait(2).to({regX:48,regY:-0.4,rotation:7.3,y:116},0).wait(2).to({regX:47.9,rotation:4,y:116.1},0).wait(2).to({regY:-0.5,rotation:1},0).to({_off:true},2).wait(92).to({_off:false},0).wait(2).to({regX:47.8,regY:-0.6,rotation:4,y:116},0).wait(2).to({regX:47.6,regY:-0.4,rotation:7.3,y:116.1},0).wait(2).to({regX:47.8,regY:-0.5,rotation:10.5},0).wait(2).to({regY:-0.2,rotation:8.5},0).wait(2).to({regY:-0.4,rotation:6.8},0).to({_off:true},37).wait(183));

	// Chameleon Tail New
	this.cham_tail = new lib.ChameleonTailNew();
	this.cham_tail.parent = this;
	this.cham_tail.setTransform(339.5,117,0.249,0.249,0,0,0,-37.8,14.5);

	this.cham_tail_1 = new lib.ChameleonTail_excited_001_1();
	this.cham_tail_1.parent = this;
	this.cham_tail_1.setTransform(339.5,117,0.249,0.249,0,0,0,-37.8,14.5);
	this.cham_tail_1._off = true;

	this.cham_tail_2 = new lib.ChameleonTail_excited_002_1();
	this.cham_tail_2.parent = this;
	this.cham_tail_2.setTransform(338.6,117.5,0.249,0.249,0,0,0,-37.8,14.5);

	this.cham_tail_3 = new lib.ChameleonTail_excited_004_1();
	this.cham_tail_3.parent = this;
	this.cham_tail_3.setTransform(338.6,117.5,0.224,0.254,0,-26.9,-15,-38.1,14.6);

	this.cham_tail_4 = new lib.ChameleonTail_excited_003_1();
	this.cham_tail_4.parent = this;
	this.cham_tail_4.setTransform(337.6,118.7,0.249,0.249,-15,0,0,-37.9,14.3);
	this.cham_tail_4._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.cham_tail}]}).to({state:[{t:this.cham_tail}]},14).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},24).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},22).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},6).to({state:[{t:this.cham_tail}]},2).to({state:[{t:this.cham_tail}]},26).to({state:[{t:this.cham_tail_1}]},14).to({state:[{t:this.cham_tail_1}]},12).to({state:[{t:this.cham_tail_1}]},2).to({state:[{t:this.cham_tail_1}]},2).to({state:[{t:this.cham_tail_1}]},2).to({state:[{t:this.cham_tail_2}]},2).to({state:[{t:this.cham_tail_3}]},2).to({state:[{t:this.cham_tail_4}]},2).to({state:[{t:this.cham_tail_4}]},2).to({state:[{t:this.cham_tail_4}]},2).to({state:[]},2).to({state:[{t:this.cham_tail_4}]},84).to({state:[{t:this.cham_tail_4}]},2).to({state:[{t:this.cham_tail_3}]},2).to({state:[{t:this.cham_tail_2}]},2).to({state:[{t:this.cham_tail_1}]},2).to({state:[{t:this.cham_tail_1}]},2).to({state:[{t:this.cham_tail_1}]},2).to({state:[{t:this.cham_tail_1}]},2).to({state:[{t:this.cham_tail_1}]},2).to({state:[]},31).to({state:[]},182).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.cham_tail).wait(14).to({regY:21.6,skewY:1.1,x:339.6,y:119.3},0).wait(2).to({regY:14.5,skewY:2.4,x:339.5,y:118},0).wait(2).to({regY:14.3,skewY:2.3},0).wait(10).to({regY:14.5,skewY:2.4},0).wait(2).to({regX:-37.7,skewX:-0.8,skewY:1.5,x:339.6,y:117.7},0).wait(2).to({regX:-38.5,regY:14.6,skewX:-1.7,skewY:0.7,x:339.5,y:117.4},0).wait(2).to({regX:-38.2,regY:14.5,skewX:-1,skewY:1.3,x:339.6,y:117.6},0).wait(2).to({regX:-38.3,regY:14.4,skewX:-0.5,skewY:1.8,y:117.8},0).wait(2).to({regX:-37.8,regY:14.5,skewX:0,skewY:2.4,x:339.5,y:118},0).wait(26).to({regY:14.3,skewY:2.3},0).wait(4).to({regY:14.5,skewY:2.4},0).wait(2).to({skewY:1.8,y:117.8},0).wait(2).to({skewY:1.3,y:117.6},0).wait(2).to({skewY:0.8,y:117.4},0).wait(2).to({skewY:0.3,y:117.2},0).wait(2).to({skewY:0,y:117},0).wait(22).to({regY:21.6,skewY:1.1,x:339.6,y:119.3},0).wait(2).to({regY:14.5,skewY:2.4,x:339.5,y:118},0).wait(6).to({regY:21.6,skewY:1.1,x:339.6,y:119.3},0).wait(2).to({regY:14.5,skewY:0,x:339.5,y:117},0).wait(26).to({_off:true},14).wait(344));
	this.timeline.addTween(cjs.Tween.get(this.cham_tail_1).wait(150).to({_off:false},0).wait(12).to({regX:-37.9,rotation:3},0).wait(2).to({rotation:6.2},0).wait(2).to({regX:-37.8,rotation:0},0).wait(2).to({regY:14.2,scaleX:0.22,scaleY:0.25,skewX:-14.7,skewY:-5.4},0).to({_off:true},2).wait(102).to({_off:false},0).wait(2).to({regY:14.5,scaleX:0.25,scaleY:0.25,skewX:0,skewY:0},0).wait(2).to({regX:-37.9,rotation:6.2},0).wait(2).to({rotation:3},0).wait(2).to({regX:-37.8,rotation:0},0).to({_off:true},31).wait(183));
	this.timeline.addTween(cjs.Tween.get(this.cham_tail_4).wait(174).to({_off:false},0).wait(2).to({regX:-38,regY:14.2,rotation:-21},0).wait(2).to({regX:-37.8,regY:14.3,rotation:-17.8},0).to({_off:true},2).wait(84).to({_off:false,regX:-38,regY:14.2,rotation:-21},0).wait(2).to({regX:-37.9,regY:14.3,rotation:-15},0).to({_off:true},2).wait(226));

	// Chameleon Foot B_001
	this.cham_frontlegback = new lib.ChameleonFootBLG_001();
	this.cham_frontlegback.parent = this;
	this.cham_frontlegback.setTransform(318.4,121.6,0.24,0.24,0,0,0,2.5,2.1);

	this.timeline.addTween(cjs.Tween.get(this.cham_frontlegback).wait(172).to({_off:true},8).wait(84).to({_off:false},0).to({_off:true},47).wait(183));

	// Chameleon Leg B Lower_001
	this.instance_37 = new lib.ChameleonLegBLowerLG_001_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(320.8,119.8,0.24,0.24,0,0,0,0.8,5.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_37).wait(14).to({regX:0.9,regY:5.6,rotation:3,y:119.9},0).wait(2).to({regX:1.1,regY:5.5,rotation:4.5,x:320.9,y:119.8},0).wait(2).to({rotation:6.2,y:119.9},0).wait(12).to({regY:5.6,rotation:0.5},0).wait(2).to({regY:5.5,rotation:-6.7,y:119.8},0).wait(2).to({regX:1,regY:5.9,rotation:-2.9,y:119.9},0).wait(2).to({regY:5.8,rotation:1.5},0).wait(2).to({regX:0.9,rotation:4.5},0).wait(36).to({regX:1.1,rotation:2.5},0).wait(2).to({rotation:0.8},0).wait(2).to({regX:1,regY:5.9,rotation:-1},0).wait(22).to({regX:1.2,regY:5.8,rotation:1.7},0).wait(2).to({regX:1.1,regY:6,rotation:6,y:120},0).wait(6).to({regX:0.9,regY:5.8,rotation:2.8,y:119.9},0).wait(2).to({regX:1,regY:5.9,rotation:-0.7},0).wait(62).to({rotation:-0.7},0).to({_off:true},8).wait(84).to({_off:false},0).to({_off:true},47).wait(183));

	// Chameleon Leg B Upper_001
	this.instance_38 = new lib.ChameleonLegBUpperLG__1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(320.1,114.3,0.24,0.24,0,0,0,2.7,3.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_38).wait(172).to({_off:true},8).wait(84).to({_off:false},0).to({_off:true},47).wait(183));

	// Chameleon Foot D_001
	this.cham_hindlegback = new lib.ChameleonFootDLG_001();
	this.cham_hindlegback.parent = this;
	this.cham_hindlegback.setTransform(333,122.7,0.24,0.24,0,0,0,4.8,1.1);

	this.timeline.addTween(cjs.Tween.get(this.cham_hindlegback).wait(172).to({_off:true},8).wait(84).to({_off:false},0).to({_off:true},47).wait(183));

	// Chameleon Leg D Lower_001
	this.instance_39 = new lib.ChameleonLegDLowerLG_001_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(333.4,121.8,0.24,0.24,0,0,0,5.4,4);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).wait(14).to({rotation:-4.5,y:121.9},0).wait(2).to({rotation:-6.7},0).wait(14).to({regX:5.7,regY:4.2,rotation:-2.9,x:333.5,y:121.8},0).wait(2).to({regY:4,y:121.7},0).wait(2).to({regX:5.4,regY:4.2,y:121.8},0).wait(2).to({regX:5.6,regY:4,rotation:-6.6},0).wait(2).to({regX:5.7,regY:4.3,rotation:-9.3,y:121.9},0).wait(34).to({regX:5.4,regY:4,rotation:-7.3},0).wait(2).to({regX:5.7,regY:4.3,rotation:-5.3},0).wait(2).to({regX:5.8,regY:4.4,rotation:-3.5},0).wait(2).to({regX:5.5,regY:4.2,rotation:-1.8,y:121.8},0).wait(22).to({regY:4,rotation:-6.1},0).wait(2).to({regY:4.2,rotation:-8.5,y:121.9},0).wait(6).to({regY:4.3,rotation:-7.3},0).wait(2).to({regX:5.8,rotation:-3.1},0).wait(52).to({regX:5.7,regY:4.4,rotation:0.2,x:333.6,y:122},0).wait(2).to({regY:4.2,rotation:1.1},0).wait(8).to({_off:true},8).wait(84).to({_off:false,regY:4.4,rotation:0,skewX:1.1,skewY:2.6},0).wait(2).to({regX:5.8,skewX:-1.3,skewY:0.1},0).wait(2).to({skewX:-1.3,skewY:0.1},0).wait(2).to({regX:6,skewY:-0.3},0).wait(2).to({regX:5.9,regY:4.5,skewX:-1.5,skewY:-1,y:121.9},0).wait(2).to({regX:5.5,regY:4.2,rotation:-1.8,skewX:0,skewY:0,x:333.5,y:121.8},0).to({_off:true},37).wait(183));

	// Chameleon Leg D Upper_001
	this.instance_40 = new lib.ChameleonLegDUpperLG_001_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(333.8,118.2,0.24,0.24,0,0,0,3.8,2.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).wait(172).to({_off:true},8).wait(84).to({_off:false},0).to({_off:true},47).wait(183));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(307,101,55.9,25.1);


(lib.chameleon = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// mouthGlow
	this.mouthGlow = new lib.chameleon_mouthGlow();
	this.mouthGlow.parent = this;
	this.mouthGlow.setTransform(194.1,193.6,1.12,1.12,0,0,0,7.1,7.4);
	this.mouthGlow.alpha = 0;
	this.mouthGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.mouthGlow.cache(-3,-1,19,18);

	this.timeline.addTween(cjs.Tween.get(this.mouthGlow).wait(1));

	// backGlow
	this.backGlow = new lib.chameleon_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(224.2,199.6,1,1,0,0,0,17.4,8.4);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.backGlow.cache(-3,-2,38,22);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// tailGlow
	this.tailGlow = new lib.chameleon_legGlow();
	this.tailGlow.parent = this;
	this.tailGlow.setTransform(261.8,198.2,1.032,1.032,0,0,0,21.6,10.8);
	this.tailGlow.alpha = 0;
	this.tailGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.tailGlow.cache(-1,-2,45,27);

	this.timeline.addTween(cjs.Tween.get(this.tailGlow).wait(1));

	// footGlow
	this.footGlow = new lib.chameleon_footGlow();
	this.footGlow.parent = this;
	this.footGlow.setTransform(232,218.1,1,1,0,0,0,6.1,1.6);
	this.footGlow.alpha = 0;
	this.footGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.footGlow.cache(-31,-8,47,14);

	this.timeline.addTween(cjs.Tween.get(this.footGlow).wait(1));

	// Layer 2
	this.tail1 = new lib.invisiblebox();
	this.tail1.parent = this;
	this.tail1.setTransform(274.4,193.6,0.421,0.385,-2.7);

	this.mouth = new lib.invisiblebox();
	this.mouth.parent = this;
	this.mouth.setTransform(193.2,192.7,0.214,0.462,135.2);

	this.foot = new lib.invisiblebox();
	this.foot.parent = this;
	this.foot.setTransform(204.8,214.6,0.375,0.223,0,28.7,9);

	this.foot_1 = new lib.invisiblebox();
	this.foot_1.parent = this;
	this.foot_1.setTransform(231.6,217.5,0.391,0.193,2.5);

	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(223.9,200.8,0.797,0.221,15.2);

	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(260.8,204.9,0.916,0.194,-2.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.tail},{t:this.back},{t:this.foot_1},{t:this.foot},{t:this.mouth},{t:this.tail1}]}).wait(1));

	// main
	this.main = new lib.Cham();
	this.main.parent = this;
	this.main.setTransform(234,198.4,1.863,1.863,0,0,0,335.1,113.1);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.chameleon, new cjs.Rectangle(181.7,175.9,107.1,51.1), null);


// stage content:
(lib.MWchameleon = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWchameleon_atlas_.png?1528313292128", id:"MWchameleon_atlas_"}
	],
	preloads: []
};




})(lib_Cham = lib_Cham||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Cham, images, createjs, ss, AdobeAn;